export default {
  first_access: false,
  token: "",
  modules: {},
  user: {},
  provider: {},
  tenant: {},
  dashboard: {
    available: false
  },
  messageToast: {},
  security: {},
  photo: "",
  accessTimeNotAllowed: false,
  sessionTime: {
    lastAccessAt: "",
    expirationTimeInSeconds: 60,
    expirationTime: 1,
    timeExpired: false,
    showModalLogin: false,
    counterStarted: false,
    shouldRenewSession: false
  },
  isMobile: false,
  termOfUseSigned: false,
  isUsingPwa: false,
  accessTimeNotAllowed: false,
  mfaValidated: false,
  confirmationType: "",
  isOnline: false,
  geolocationRequired: false,
  userEmailValidated: false,
  userPhoneValidated: false,
  canSkipContactValidation: false,
  showModalUserContactsConfirmation: false,
  daysToContactValidationDeadline: ""
}
